export default {
  list: {
    title: 'orders',
    name: 'orders',
    class: 'min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center',
    sousTable: true,
    options: {
      defaultPageSize: 5,
      actions: {
        isActive: true,
        method: true,
        name: 'Actions',
        buttons: [
          {
            text: "new_order",
            access: "create",
            icon: "add",
            action: "newOrder",
            color: "primary"
          },
          {
            text: "import_orders",
            access: "create",
            icon: "cloud_upload",
            action: "importOrders",
            color: "primary"
          },
          {
            text: "change_status",
            access: "update",
            icon: "update",
            action: "changestatus",
            color: "primary"
          }
        ],
      },
    },
    columns: [
      {
        type: 'checkbox',
        elements: [
          {
            items: [
              {
                class: '',
                type: 'checkbox',
              },
            ],
          },
        ],
      },
      {
        name: 'id',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'id',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'source',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'source',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'shipper',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'traitBy',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'trackingnumber',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'trackingNumber',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'seller',
        elements: [
          {
            items: [
              {
                class: 'ouka',
                name: 'seller',
                elements: [
                  {
                    items: [
                      {
                        name: 'company',
                        class: 'font-light text-gray-700',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'customer',
        elements: [
          {
            items: [
              {
                class: 'ouka',
                name: 'customer',
                elements: [
                  {
                    items: [
                      {
                        name: 'fullName',
                        icone: 'contacts',
                      },
                      {
                        name: 'phone',
                        class: 'font-light text-gray-700',
                        icone: 'phone',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'details',
        model: 'order',
        title: 'products',
      },
      {
        name: 'city',
        elements: [
          {
            items: [
              {
                class: 'ouka',
                name: 'customer',
                elements: [
                  {
                    items: [
                      {
                        name: 'city',
                        class: 'font-light text-gray-700',
                        icone: 'map',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'totalprice',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'totalPrice',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'order-date',
        class: '',
        elements: [
          {
            items: [
              {
                class: '',
                date: true,
                name: 'createdAt',
                type: 'text',
              },
            ],
          },
        ],
      },
      {
        name: 'status',
        class: 'text-center',
        elements: [
          {
            items: [
              {
                class:
                  'border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none',
                name: 'status',
                data: true,
                champs: {
                  name: 'name',
                  color: 'color',
                },
              },
            ],
          },
        ],
      },
      {
        name: 'ship-status',
        class: 'text-center',
        elements: [
          {
            items: [
              {
                class: '',
                name: 'shippingStatus',
                data: true,
                champs: {
                  name: 'name',
                  color: 'color',
                },
              },
            ],
          },
        ],
      },
    ],
    columnsDialog: {
      details: 'details',
      elements: [
        {
          class: '',
          name: 'image',
          referent: 'product',
          items: [
            {
              name: 'picture',
            },
          ],
        },
        {
          class: '',
          name: 'warehouse',
          items: [
            {
              name: 'warehouseParentName',
            },
          ],
        },
        {
          class: '',
          name: 'name',
          referent: 'product',
          items: [
            {
              name: 'name',
            },
          ],
        },
        {
          class: '',
          name: 'code',
          referent: 'product',
          items: [
            {
              name: 'code',
            },
          ],
        },
        {
          class: '',
          name: 'unit_price',
          items: [
            {
              name: 'unitPrice',
            },
          ],
        },
        {
          class: '',
          name: 'quantity',
          items: [
            {
              name: 'quantity',
            },
          ],
        },
      ],
    },
    actions: {
      name: 'actions',
      width: '10px',
      class: 'justify-end',
      elements: [
        {
          icone: 'remove_red_eye',
          color: 'success',
          key: 'read',
          id: '',
          role: true,
          link: '/orders/detail',
          tooltip: 'Update',
        },
        {
          icone: 'edit',
          color: 'success',
          role: true,
          key: 'update',
          link: '/orders/edit',
          tooltip: 'Update',
        },
        {
          icone: 'delete',
          color: 'danger',
          role: true,
          key: 'delete',
          tooltip: 'Delete',
        },
      ],
    },
    filters: {
      name: 'orders',
      hasFilterdate: false,
      elements: {
        search: {
          options: {
            icon: 'search',
            label: 'search',
            class: '',
            hint: 'search_order',
          },
          value: null,
          type: 'search',
          validate: {
            trim: true,
            required: false,
            minlength: 0,
          },
        },
        champs: [
          {
            label: 'status',
            key: 'status',
            name: 'name',
            value: null,
            values: [],
            class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'pending status',
            key: 'status_pending',
            name: 'name',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'shipping status',
            key: 'shippingStatus',
            name: 'name',
            value: null,
            values: [],
            class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'city',
            key: 'city',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'seller',
            key: 'seller',
            name: 'company',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'product',
            key: 'product',
            name: 'name',
            value: null,
            values: [],
            class:
              'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'Affiliate stores',
            key: 'affiliate_stores',
            name: 'affiliate_stores',
            value: null,
            values: [],
            class:
              'py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white',
            type: 'select',
          },
          {
            label: 'Order date',
            key: 'Range_date',
            value: null,
            placeholder: 'Date Range ...',
            type: 'date_range',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
          {
            label: 'From',
            key: 'from',
            value: null,
            placeholder: 'Date',
            type: 'date',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
          {
            label: 'To',
            key: 'to',
            value: null,
            placeholder: 'Date',
            type: 'date',
            class: 'py-2 text-xs px-2 outline-none block h-full w-full',
          },
        ],
      },
    },
  },
};
